import axios from "axios";

export const api = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
    withCredentials: true,
});

export const formatApiError = (err) => {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
    if (typeof detail.msg === "string") return detail.msg;
    return String(detail);
};

const TRACK_MATCHERS = [
    [/wa\.me|whatsapp/i, "whatsapp"],
    [/^tel:/i, "call"],
    [/^mailto:/i, "email"],
    [/instagram\.com/i, "instagram"],
];

export const trackClick = (href, page) => {
    const match = TRACK_MATCHERS.find(([re]) => re.test(href));
    if (!match) return;
    api.post("/events", { type: match[1], page }).catch(() => {});
};
